export const isNumber = (value) => {
  return value ? typeof value === 'number' : false;
};

export const hasHash = (value) => {
  return value ? value.includes('#') : false;
};
